import {useMemo} from "react";

import {dateTimeFormat, formatDate, priceFormat, priceM2Format} from "@pg-mono/string-utils";

import {replaceDigitsWithZeros} from "../../credit_calculator/utils/replace_digits_with_zeros";
import type {PropertyPriceHistoryDTO} from "../types/PropertyPriceHistoryDTO";

interface IPriceHistoryRow {
    formattedDate: string;
    changePercent: number;
    absoluteChange: number;
    isIncrease: boolean;
    isDecrease: boolean;
    changeAmountDisplay: string;
    priceTotalDisplay: string;
    priceM2Display: string;
    row: PropertyPriceHistoryDTO;
    index: number;
}

interface IPropertyPriceHistoryValues {
    priceHistory: PropertyPriceHistoryDTO[] | undefined;
    isAuthenticated: boolean;
    isAbroad?: boolean;
}

interface IPropertyPriceHistoryValuesReturn {
    publicationDate: string | null;
    updateDate: string | null;
    rows: IPriceHistoryRow[];
}

export const useGetPropertyPriceHistoryValues = ({priceHistory, isAuthenticated, isAbroad}: IPropertyPriceHistoryValues): IPropertyPriceHistoryValuesReturn => {
    return useMemo(() => {
        if (!priceHistory || priceHistory.length === 0) {
            return {
                publicationDate: null,
                updateDate: null,
                rows: []
            };
        }
        const publicationDate = formatDate(priceHistory[priceHistory.length - 1].create_date, dateTimeFormat.shortDate);
        const updateDate = formatDate(priceHistory[0].create_date, dateTimeFormat.shortDate);
        const unit = isAbroad ? "eur" : "zł";

        const rows: IPriceHistoryRow[] = priceHistory.map((row: PropertyPriceHistoryDTO, index: number) => {
            const absoluteChange = index < priceHistory.length - 1 ? priceHistory[index + 1].price - row.price : 0;
            const isIncrease = absoluteChange < 0;
            const isDecrease = absoluteChange > 0;
            const changeAmountFormatted = absoluteChange === 0 ? "—" : `${isIncrease ? "+" : "-"}${priceFormat(Math.abs(absoluteChange), {unit})}`;

            return {
                formattedDate: formatDate(row.create_date, dateTimeFormat.shortDate),
                changePercent: row.change,
                absoluteChange,
                isIncrease,
                isDecrease,
                changeAmountDisplay: formatDisplayValue(changeAmountFormatted, isAuthenticated),
                priceTotalDisplay: formatDisplayValue(priceFormat(row.price, {unit}) ?? "", isAuthenticated),
                priceM2Display: formatDisplayValue(priceM2Format(row.price_m2, {unit}) ?? "", isAuthenticated),
                row,
                index
            };
        });

        return {
            publicationDate,
            updateDate,
            rows
        };
    }, [priceHistory, isAuthenticated]);
};

const formatDisplayValue = (value: string, isAuthenticated: boolean): string => {
    return !isAuthenticated ? replaceDigitsWithZeros(value) : value;
};
import {useMemo} from "react";

import {dateTimeFormat, formatDate, priceFormat, priceM2Format} from "@pg-mono/string-utils";

import {replaceDigitsWithZeros} from "../../credit_calculator/utils/replace_digits_with_zeros";
import type {PropertyPriceHistoryDTO} from "../types/PropertyPriceHistoryDTO";

interface IPriceHistoryRow {
    formattedDate: string;
    changePercent: number;
    absoluteChange: number;
    isIncrease: boolean;
    isDecrease: boolean;
    changeAmountDisplay: string;
    priceTotalDisplay: string;
    priceM2Display: string;
    row: PropertyPriceHistoryDTO;
    index: number;
}

interface IPropertyPriceHistoryValues {
    priceHistory: PropertyPriceHistoryDTO[] | undefined;
    isAuthenticated: boolean;
    isAbroad?: boolean;
}

interface IPropertyPriceHistoryValuesReturn {
    publicationDate: string | null;
    updateDate: string | null;
    rows: IPriceHistoryRow[];
}

export const useGetPropertyPriceHistoryValues = ({priceHistory, isAuthenticated, isAbroad}: IPropertyPriceHistoryValues): IPropertyPriceHistoryValuesReturn => {
    return useMemo(() => {
        if (!priceHistory || priceHistory.length === 0) {
            return {
                publicationDate: null,
                updateDate: null,
                rows: []
            };
        }
        const publicationDate = formatDate(priceHistory[priceHistory.length - 1].create_date, dateTimeFormat.shortDate);
        const updateDate = formatDate(priceHistory[0].create_date, dateTimeFormat.shortDate);
        const unit = isAbroad ? "eur" : "zł";

        const rows: IPriceHistoryRow[] = priceHistory.map((row: PropertyPriceHistoryDTO, index: number) => {
            const absoluteChange = index < priceHistory.length - 1 ? priceHistory[index + 1].price - row.price : 0;
            const isIncrease = absoluteChange < 0;
            const isDecrease = absoluteChange > 0;
            const changeAmountFormatted = absoluteChange === 0 ? "—" : `${isIncrease ? "+" : "-"}${priceFormat(Math.abs(absoluteChange), {unit})}`;

            return {
                formattedDate: formatDate(row.create_date, dateTimeFormat.shortDate),
                changePercent: row.change,
                absoluteChange,
                isIncrease,
                isDecrease,
                changeAmountDisplay: formatDisplayValue(changeAmountFormatted, isAuthenticated),
                priceTotalDisplay: formatDisplayValue(priceFormat(row.price, {unit}) ?? "", isAuthenticated),
                priceM2Display: formatDisplayValue(priceM2Format(row.price_m2, {unit}) ?? "", isAuthenticated),
                row,
                index
            };
        });

        return {
            publicationDate,
            updateDate,
            rows
        };
    }, [priceHistory, isAuthenticated]);
};

const formatDisplayValue = (value: string, isAuthenticated: boolean): string => {
    return !isAuthenticated ? replaceDigitsWithZeros(value) : value;
};
